export var styleRoot = 'kvfysmfp';
export var styleChild = 'ufhsfnkm';
export var styles = ".".concat(styleRoot, "{overflow:hidden;touch-action:none}.").concat(styleChild, "{transform-origin: 0 0}");
